
// import React, { useContext, useState } from 'react';
// import { Box, Button, List, ListItem, Text, Spinner, Image, Flex, Alert, AlertIcon } from '@chakra-ui/react';
// import { Link } from 'react-router-dom';
// import DepositContext from './DepositContext';
// import Pagination from './Pagination';

// const DepositList = () => {
//   const { deposits, deleteDeposit, updateDeposit, filterStatus,updateDepositregected } = useContext(DepositContext);
//   const [currentPage, setCurrentPage] = useState(1);
//   const depositsPerPage = 10;

//   if (!deposits) {
//     return <Spinner />;
//   }

//   const filteredDeposits = deposits.data.data.filter(deposit =>
//     filterStatus === 'all' || deposit.status === filterStatus
//   );

//   const indexOfLastDeposit = currentPage * depositsPerPage;
//   const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
//   const currentDeposits = filteredDeposits.slice(indexOfFirstDeposit, indexOfLastDeposit);

//   const paginate = pageNumber => setCurrentPage(pageNumber);

//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposits ({filteredDeposits.length})</Text>
//       <List spacing={3}>
//         {currentDeposits.map(deposit => (
//           <ListItem key={deposit._id}>
//             <Flex justifyContent="space-between" alignItems="center">
//               <Flex alignItems="center">
//                 <Image boxSize="50px" src={`http://localhost:9000/${deposit.item.coverphoto.path}`} alt={deposit.item.name} mr={4} />
//                 <Text>{deposit.item.name} - {deposit.amount} - {deposit.status}</Text>
//               </Flex>
//               <Flex alignItems="center">
//                 <Link to={`/dashboard/admin/deposit/${deposit._id}`}>
//                   <Button mr={2} colorScheme="teal">View</Button>
//                 </Link>
//                 <Button colorScheme="green" onClick={() => updateDeposit(deposit._id, 'approved')}>Approve</Button>
//                 <Button colorScheme="yellow" onClick={() => updateDepositregected(deposit._id, 'rejected')} ml={2}>Reject</Button>
//                 <Button colorScheme="red" onClick={() => deleteDeposit(deposit._id)} ml={2}>Delete</Button>
//               </Flex>
//             </Flex>
//           </ListItem>
//         ))}
//       </List>
//       <Pagination
//         depositsPerPage={depositsPerPage}
//         totalDeposits={filteredDeposits.length}
//         paginate={paginate}
//       />
//     </Box>
//   );
// };

// export default DepositList;


// import React, { useContext, useState } from 'react';
// import { Box, Button, List, ListItem, Text, Spinner, Image, Flex, Alert, AlertIcon } from '@chakra-ui/react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import DepositContext from './DepositContext';
// import Pagination from './Pagination';

// const DepositList = () => {
//   const { deposits, deleteDeposit, updateDeposit, updateDepositregected, filterStatus } = useContext(DepositContext);
//   const [currentPage, setCurrentPage] = useState(new URLSearchParams(useLocation().search).get('page') || 1);
//   const depositsPerPage = 10;
//   const history = useNavigate();

//   const paginate = pageNumber => {
//     setCurrentPage(pageNumber);
//     history(`/dashboard/admin/deposits?page=${pageNumber}`);
//   };

//   if (!deposits) {
//     return <Spinner />;
//   }

//   const filteredDeposits = deposits.data.data.filter(deposit =>
//     filterStatus === 'all' || deposit.status === filterStatus
//   );

//   const indexOfLastDeposit = currentPage * depositsPerPage;
//   const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
//   const currentDeposits = filteredDeposits.slice(indexOfFirstDeposit, indexOfLastDeposit);

//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposits ({filteredDeposits.length})</Text>
//       <List spacing={3}>
//         {currentDeposits.map(deposit => (
//           <ListItem key={deposit._id}>
//             <Flex justifyContent="space-between" alignItems="center">
//               {/* <Flex alignItems="center">
//                 <Image boxSize="50px" src={`http://localhost:9000/${deposit.item.imagecover.path}`} alt={deposit.item.name} mr={4} />
//               </Flex> */}
//               <Text>{deposit.item.name} - {deposit.item._id}- {deposit.amount} - {deposit.status}</Text>
//               <Flex alignItems="center">
//                 <Link to={`/dashboard/admin/deposit/${deposit._id}`}>
//                   <Button mr={2} colorScheme="teal">View</Button>
//                 </Link>
//                 <Button colorScheme="green" onClick={() => {
//                   if (window.confirm('Are you sure you want to approve this deposit?')) {
//                     updateDeposit(deposit._id, 'approved');
//                   }
//                 }}>Approve</Button>
//                 <Button colorScheme="yellow" onClick={() => {
//                   if (window.confirm('Are you sure you want to reject this deposit?')) {
//                     updateDepositregected(deposit._id, 'rejected');
//                   }
//                 }} ml={2}>Reject</Button>
//                 <Button colorScheme="red" onClick={() => {
//                   if (window.confirm('Are you sure you want to delete this deposit?')) {
//                     deleteDeposit(deposit._id);
//                   }
//                 }} ml={2}>Delete</Button>
//               </Flex>
//             </Flex>
//           </ListItem>
//         ))}
//       </List>
//       <Pagination
//         depositsPerPage={depositsPerPage}
//         totalDeposits={filteredDeposits.length}
//         paginate={paginate}
//       />
//     </Box>
//   );
// };

// export default DepositList;


// import React, { useContext, useState, useEffect } from 'react';
// import { Box, Button, List, ListItem, Text, Spinner, Flex, Select, Input } from '@chakra-ui/react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import DepositContext from './DepositContext';
// import Pagination from './Pagination';

// const DepositList = () => {
//   const { deposits, deleteDeposit, updateDeposit, updateDepositregected, setFilterStatus, filterStatus, fetchDeposits } = useContext(DepositContext);
//   const [currentPage, setCurrentPage] = useState(new URLSearchParams(useLocation().search).get('page') || 1);
//   const depositsPerPage = 10;
//   const history = useNavigate();
//   const [subcategoryId, setSubcategoryId] = useState('');

//   // useEffect(() => {
//   //   fetchDeposits();
//   // }, [filterStatus, subcategoryId, currentPage]);

//   const handleFilterChange = (e) => {
//     setFilterStatus(e.target.value);
//   };

//   const handleSubcategoryFilter = (e) => {
//     setSubcategoryId(e.target.value);
//   };

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     history(`/dashboard/admin/deposits?page=${pageNumber}`);
//   };

//   if (!deposits) {
//     return <Spinner />;
//   }

//   const filteredDeposits = deposits.data.data.filter(deposit => {
//     return (filterStatus === 'all' || deposit.status === filterStatus) &&
//       (!subcategoryId || deposit.item.categoryId._id === subcategoryId);
//   });

//   const indexOfLastDeposit = currentPage * depositsPerPage;
//   const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
//   const currentDeposits = filteredDeposits.slice(indexOfFirstDeposit, indexOfLastDeposit);

//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposits ({filteredDeposits.length})</Text>
//       <Flex mb={4} justifyContent="space-between">
//         <Select placeholder="Filter by status" onChange={handleFilterChange} value={filterStatus}>
//           <option value="all">All</option>
//           <option value="approved">Approved</option>
//           <option value="rejected">Rejected</option>
//           <option value="pending">Pending</option>
//         </Select>
//         <Input placeholder="Filter by Subcategory ID" onChange={handleSubcategoryFilter} value={subcategoryId} />
//       </Flex>
//       <List spacing={3}>
//         {currentDeposits.map(deposit => (
//           <ListItem key={deposit._id}>
//             <Flex justifyContent="space-between" alignItems="center">
//               <Text>{deposit.item.name} - {deposit.amount} - {deposit.status}</Text>
//               <Flex alignItems="center">
//                 <Link to={`/dashboard/admin/deposit/${deposit._id}`}>
//                   <Button mr={2} colorScheme="teal">View</Button>
//                 </Link>
//                 <Button colorScheme="green" onClick={() => {
//                   if (window.confirm('Are you sure you want to approve this deposit?')) {
//                     updateDeposit(deposit._id, 'approved');
//                   }
//                 }}>Approve</Button>
//                 <Button colorScheme="yellow" onClick={() => {
//                   if (window.confirm('Are you sure you want to reject this deposit?')) {
//                     updateDepositregected(deposit._id, 'rejected');
//                   }
//                 }} ml={2}>Reject</Button>
//                 <Button colorScheme="red" onClick={() => {
//                   if (window.confirm('Are you sure you want to delete this deposit?')) {
//                     deleteDeposit(deposit._id);
//                   }
//                 }} ml={2}>Delete</Button>
//               </Flex>
//             </Flex>
//           </ListItem>
//         ))}
//       </List>
//       <Pagination
//         depositsPerPage={depositsPerPage}
//         totalDeposits={filteredDeposits.length}
//         paginate={paginate}
//       />
//     </Box>
//   );
// };

// export default DepositList;


// import React, { useContext, useState, useEffect } from 'react';
// import { Box, Button, List, ListItem, Text, Spinner, Flex, Select, VStack, Input } from '@chakra-ui/react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import DepositContext from './DepositContext';
// import Pagination from './Pagination';

// const DepositList = () => {
//   const { deposits, subcategories, deleteDeposit, updateDeposit, updateDepositregected, setFilterStatus, filterStatus, setSubcategoryId, subcategoryId, fetchDeposits } = useContext(DepositContext);
//   const [currentPage, setCurrentPage] = useState(new URLSearchParams(useLocation().search).get('page') || 1);
//   const depositsPerPage = 10;
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchDeposits();
//   }, [filterStatus, subcategoryId, currentPage]);

//   const handleFilterChange = (e) => {
//     setFilterStatus(e.target.value);
//   };

//   const handleSubcategoryFilter = (id) => {
//     setSubcategoryId(id);
//     navigate(`/dashboard/admin/deposit?item=${id}`);
//   };
// console.log(subcategories)
//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     navigate(`/dashboard/admin/deposit?page=${pageNumber}&limit=10`);
//   };

//   if (!deposits) {
//     return <Spinner />;
//   }

//   const filteredDeposits = deposits.data.data.filter(deposit => {
//     return (filterStatus === 'all' || deposit.status === filterStatus) &&
//       (!subcategoryId || deposit.item.categoryId._id === subcategoryId);
//   });

//   const indexOfLastDeposit = currentPage * depositsPerPage;
//   const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
//   const currentDeposits = filteredDeposits.slice(indexOfFirstDeposit, indexOfLastDeposit);
// console.log(subcategories)
//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposits ({filteredDeposits.length})</Text>
//       <Flex mb={4} justifyContent="space-between">
//         {/* <Select placeholder="Filter by status" onChange={handleFilterChange} value={filterStatus}>
//           <option value="all">All</option>
//           <option value="approved">Approved</option>
//           <option value="rejected">Rejected</option>
//           <option value="pending">Pending</option>
//         </Select> */}
//         {/* <VStack align="start" overflowY="scroll" maxH="200px">
//           {subcategories?.map(subcategory => (
//             <Button key={subcategory?.subcategory?._id} onClick={() => handleSubcategoryFilter(subcategory._id)}>
//               {subcategory?.subcategory?.name}
//             </Button>
//           ))}
//         </VStack> */}
//       </Flex>
//       <List spacing={3}>
//         {currentDeposits.map(deposit => (
//           <ListItem key={deposit._id}>
//             <Flex justifyContent="space-between" alignItems="center">
//             <Text>{deposit.item.name} - {deposit.amount} - {deposit.status}</Text>

//               <Text>{deposit.item.name} - {deposit.amount} - {deposit.status}</Text>
//               <Flex alignItems="center">
//                 <Link to={`/dashboard/admin/deposit/${deposit._id}`}>
//                   <Button mr={2} colorScheme="teal">View</Button>
//                 </Link>
//                 <Button colorScheme="green" onClick={() => {
//                   if (window.confirm('Are you sure you want to approve this deposit?')) {
//                     updateDeposit(deposit._id, 'approved');
//                   }
//                 }}>Approve</Button>
//                 <Button colorScheme="yellow" onClick={() => {
//                   if (window.confirm('Are you sure you want to reject this deposit?')) {
//                     updateDepositregected(deposit._id, 'rejected');
//                   }
//                 }} ml={2}>Reject</Button>
//                 <Button colorScheme="red" onClick={() => {
//                   if (window.confirm('Are you sure you want to delete this deposit?')) {
//                     deleteDeposit(deposit._id);
//                   }
//                 }} ml={2}>Delete</Button>
//               </Flex>
//             </Flex>
//           </ListItem>
//         ))}
//       </List>
//       <Pagination
//         depositsPerPage={depositsPerPage}
//         totalDeposits={filteredDeposits.length}
//         paginate={paginate}
//       />
//     </Box>
//   );
// };

// export default DepositList;





















// import React, { useContext, useState, useEffect } from 'react';
// import { Box, Button, List, ListItem, Text, Spinner, Flex, Select, VStack, Table, Tbody, Tr, Th, Td, Thead } from '@chakra-ui/react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import DepositContext from './DepositContext';
// import Pagination from './Pagination';

// const DepositList = () => {
//   const { deposits, subcategories, deleteDeposit, updateDeposit, updateDepositregected, setFilterStatus, filterStatus, setSubcategoryId, subcategoryId, fetchDeposits } = useContext(DepositContext);
//   const [currentPage, setCurrentPage] = useState(new URLSearchParams(useLocation().search).get('page') || 1);
//   const depositsPerPage = 10;
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchDeposits();
//   }, [filterStatus, subcategoryId, currentPage]);

//   const handleFilterChange = (e) => {
//     setFilterStatus(e.target.value);
//   };

//   const handleSubcategoryFilter = (id) => {
//     setSubcategoryId(id);
//     navigate(`/dashboard/admin/deposit?item=${id}`);
//   };

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     navigate(`/dashboard/admin/deposit?page=${pageNumber}&limit=10`);
//   };

//   if (!deposits) {
//     return <Spinner />;
//   }

//   const filteredDeposits = deposits.data.data.filter(deposit => {
//     return (filterStatus === 'all' || deposit.status === filterStatus) &&
//       (!subcategoryId || deposit.item.categoryId._id === subcategoryId);
//   });

//   const indexOfLastDeposit = currentPage * depositsPerPage;
//   const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
//   const currentDeposits = filteredDeposits.slice(indexOfFirstDeposit, indexOfLastDeposit);
// console.log(deposits.data.data)
//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposits ({filteredDeposits.length})</Text>
//       {/* <Flex mb={4} justifyContent="space-between">
//         <Select placeholder="Filter by status" onChange={handleFilterChange} value={filterStatus}>
//           <option value="all">All</option>
//           <option value="approved">Approved</option>
//           <option value="rejected">Rejected</option>
//           <option value="pending">Pending</option>
//         </Select>
//         <VStack align="start" overflowY="scroll" maxH="200px">
//           {subcategories?.map(subcategory => (
//             <Button key={subcategory?._id} onClick={() => handleSubcategoryFilter(subcategory._id)}>
//               {subcategory?.name}
//             </Button>
//           ))}
//         </VStack>
//       </Flex> */}
//       <Table variant="simple">
//         <Thead>
//           <Tr>
//             <Th>Auction</Th>
//             <Th>Status</Th>
//             <Th>User Phone</Th>
//             <Th>User Name</Th>
//             <Th>Created At</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {currentDeposits.map(deposit => (
//             <Tr key={deposit?._id}>
//               <Td>{deposit?.item?.name}</Td>
//               <Td>{deposit?.status}</Td>
//               <Td>{deposit?.userId?.phoneNumber}</Td>
//               <Td>{deposit?.userId?.name}</Td>
//               <Td>{new Date(deposit?.createdAt).toLocaleString()}</Td>
//               <Td>
//                 <Flex alignItems="center">
//                   <Link to={`/dashboard/admin/deposit/${deposit._id}`}>
//                     <Button mr={2} colorScheme="teal">View</Button>
//                   </Link>
//                   <Button 
//                     isDisabled={deposit.status !== 'pending'}
//                     colorScheme="green" onClick={() => {
//                     if (window.confirm('Are you sure you want to approve this deposit?')) {
//                       updateDeposit(deposit._id, 'approved');
//                     }
//                   }}>Approve</Button>
//                   <Button 
//                     isDisabled={deposit.status !== 'pending'}

//                   colorScheme="yellow" onClick={() => {
//                     if (window.confirm('Are you sure you want to reject this deposit?')) {
//                     updateDepositregected(deposit._id, 'rejected');
                 
//                     }
//                   }} ml={2}>Reject</Button>
//                   <Button colorScheme="red" onClick={() => {
//                     if (window.confirm('Are you sure you want to delete this deposit?')) {
//                       deleteDeposit(deposit._id);
//                     }
//                   }} ml={2}>Delete</Button>
//                 </Flex>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Pagination
//         depositsPerPage={depositsPerPage}
//         totalDeposits={filteredDeposits.length}
//         paginate={paginate}
//       />
//     </Box>
//   );
// };

// export default DepositList;












import React, { useContext, useState, useEffect } from 'react';
import { Box, Button, List, ListItem, Text, Spinner, Flex, Select, VStack, Table, Tbody, Tr, Th, Td, Thead, Input } from '@chakra-ui/react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import DepositContext from './DepositContext';
import Pagination from './Pagination';

const DepositList = () => {
  const {
    deposits,
    subcategories,
    deleteDeposit,
    updateDeposit,
    updateDepositregected,
    setFilterStatus,
    filterStatus,
    setSubcategoryId,
    subcategoryId,
    fetchDeposits
  } = useContext(DepositContext);
  
  const [currentPage, setCurrentPage] = useState(new URLSearchParams(useLocation().search).get('page') || 1);
  const [searchPhone, setSearchPhone] = useState('');  // New state for phone number search
  const depositsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeposits();
  }, [filterStatus, subcategoryId, currentPage]);

  const handleFilterChange = (e) => {
    setFilterStatus(e.target.value);
  };

  const handleSubcategoryFilter = (id) => {
    setSubcategoryId(id);
    navigate(`/dashboard/admin/deposit?item=${id}`);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    navigate(`/dashboard/admin/deposit?page=${pageNumber}&limit=10`);
  };

  if (!deposits) {
    return <Spinner />;
  }

  // Filter deposits by status, subcategory, and phone number
  const filteredDeposits = deposits.data.data.filter(deposit => {
    return (
      (filterStatus === 'all' || deposit.status === filterStatus) &&
      (!subcategoryId || deposit.item.categoryId._id === subcategoryId) &&
      (!searchPhone || deposit.userId.phoneNumber.includes(searchPhone))  // Phone number filtering
    );
  });

  const indexOfLastDeposit = currentPage * depositsPerPage;
  const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
  const currentDeposits = filteredDeposits.slice(indexOfFirstDeposit, indexOfLastDeposit);

  return (
    <Box>
      <Text fontSize="2xl" mb={4}>Deposits ({filteredDeposits.length})</Text>
      
      {/* Search and Filter Controls */}
      <Flex mb={4} justifyContent="space-between">
        <Select placeholder="Filter by status" onChange={handleFilterChange} value={filterStatus}>
          <option value="all">All</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="pending">Pending</option>
        </Select>
        <Input
          placeholder="Search by phone number"
          value={searchPhone}
          onChange={(e) => setSearchPhone(e.target.value)}  // Update search input
          width="300px"
        />
        <VStack align="start" overflowY="scroll" maxH="200px">
          {subcategories?.map(subcategory => (
            <Button key={subcategory?._id} onClick={() => handleSubcategoryFilter(subcategory._id)}>
              {subcategory?.name}
            </Button>
          ))}
        </VStack>
      </Flex>

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Auction</Th>
            <Th>Status</Th>
            <Th>User Phone</Th>
            <Th>User Name</Th>
            <Th>Created At</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentDeposits.map(deposit => (
            <Tr key={deposit?._id}>
              <Td>{deposit?.item?.name}</Td>
              <Td>{deposit?.status}</Td>
              <Td>{deposit?.userId?.phoneNumber}</Td>
              <Td>{deposit?.userId?.name}</Td>
              <Td>{new Date(deposit?.createdAt).toLocaleString()}</Td>
              <Td>
                <Flex alignItems="center">
                  <Link to={`/dashboard/admin/deposit/${deposit._id}`}>
                    <Button mr={2} colorScheme="teal">View</Button>
                  </Link>
                  <Button 
                    isDisabled={deposit.status !== 'pending'}
                    colorScheme="green"
                    onClick={() => {
                      if (window.confirm('Are you sure you want to approve this deposit?')) {
                        updateDeposit(deposit._id, 'approved');
                      }
                    }}>
                    Approve
                  </Button>
                  <Button 
                    isDisabled={deposit.status !== 'pending'}
                    colorScheme="yellow"
                    onClick={() => {
                      if (window.confirm('Are you sure you want to reject this deposit?')) {
                        updateDepositregected(deposit._id, 'rejected');
                      }
                    }} 
                    ml={2}>
                    Reject
                  </Button>
                  <Button 
                    colorScheme="red"
                    onClick={() => {
                      if (window.confirm('Are you sure you want to delete this deposit?')) {
                        deleteDeposit(deposit._id);
                      }
                    }} 
                    ml={2}>
                    Delete
                  </Button>
                </Flex>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {/* Pagination Controls */}
      <Pagination
        depositsPerPage={depositsPerPage}
        totalDeposits={filteredDeposits.length}
        paginate={paginate}
      />
    </Box>
  );
};

export default DepositList;







